import { getLoyaltyPopMessage } from '@/api/mkt';
import { WeeeIcon } from '@/components/common/Icon';
import { hideLoading, showLoading } from '@/components/common/Indicator/pageIndicator';
import { ISize } from '@/types/cms';
import { CroppedImage } from '@weee-fe/module';
import classNames from 'classnames';
import Trans from 'next-translate/Trans';
import dynamic from 'next/dynamic';
import React, { useState } from 'react';
import { twMerge } from 'tailwind-merge';
import styles from './index.module.scss';

type Props = {
  text?: string;
  littleSize?: boolean;
  showLevelIcon?: boolean;
  showInfoIcon?: boolean;
  className?: string;
  infoIconClassName?: string;
  levelIconType?: number;
  levelIcon?: string;
  messageType?: string;
  titleStyle?: ObjectType;
  customIcon?: React.ReactNode;
  textStyle?: React.CSSProperties;
};

const LoyaltyModal = dynamic(() => import('@/components/rewards/RewardsModal'), {
  ssr: false
});

const LoyaltyIcon = ({
  text,
  littleSize = false,
  levelIconType = 1,
  messageType,
  levelIcon,
  showLevelIcon = true,
  showInfoIcon = true,
  infoIconClassName,
  titleStyle = {},
  className,
  customIcon,
  textStyle = {}
}: Props) => {
  const [showLoyaltyModal, setShowLoyaltyModal] = useState<boolean>(false);
  const [message, setMessage] = useState<any>({});

  const handleShowModal = async e => {
    e.stopPropagation();
    if (!messageType) return;
    showLoading();
    const res = await getLoyaltyPopMessage({ special_message: 'loyalty', project_name: messageType });
    if (res?.result) {
      hideLoading();
      setMessage(res?.object?.loyalty_popup_copy);
      setShowLoyaltyModal(true);
    }
  };
  return (
    <>
      {showLoyaltyModal && (
        <LoyaltyModal
          visible
          message={message}
          onClose={() => {
            setShowLoyaltyModal(false);
          }}
        />
      )}

      <div
        className={classNames(styles.iconContainer, 'max-w-full cursor-pointer', className)}
        style={textStyle}
        onClick={handleShowModal}>
        {showLevelIcon && (
          <>
            {levelIconType === 1 ? (
              <div className={classNames(styles.iconSection, 'mr-1')}>
                {levelIcon && (
                  <CroppedImage
                    className={styles.levelIconImg}
                    url={levelIcon}
                    alt="level icon image"
                    showErrorPlaceholder={false}
                    showLoadingPlaceholder={false}
                  />
                )}
              </div>
            ) : (
              <WeeeIcon
                className={classNames(
                  styles.iconLoyalty,
                  { [styles.littleSize]: littleSize },
                  { [styles.hollow]: levelIconType === 2 },
                  'mr-1'
                )}
                type="iconloyalty-hollow"
              />
            )}
          </>
        )}
        {text && (
          <div
            className={classNames(
              'enki-body-base-medium flex-1 overflow-hidden text-ellipsis whitespace-nowrap',
              {
                '!text-[14px]': titleStyle?.font_size === (ISize.small as string)
              },
              {
                '!text-[17px]': titleStyle?.font_size === (ISize.middle as string)
              },
              {
                '!text-[20px]': titleStyle?.font_size === (ISize.large as string)
              }
            )}
            style={{
              textAlign: titleStyle?.align,
              color: titleStyle?.color
            }}>
            <Trans
              i18nKey={text}
              components={{ points: <WeeeIcon className={styles.titleLogo} type="iconweee-points" /> }}
            />
          </div>
        )}
        {showInfoIcon && (
          <WeeeIcon
            className={twMerge(classNames(styles.iconInfo, 'ml-1 relative top-[1px]', infoIconClassName))}
            type="iconinfo2"
          />
        )}
        {customIcon && <div className="ml-1">{customIcon}</div>}
      </div>
    </>
  );
};
export default LoyaltyIcon;
